/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from '../styles/audioPreview.css';

const AudioPreview = ({
  className = styles.audioSvg,
  propsStyle = {}
}) => (
  <svg
    id="audioSelectPreview"
    style={propsStyle}
    className={className} />
);

AudioPreview.propTypes = {
  className: PropTypes.string,
  propsStyle: PropTypes.object
};

export default AudioPreview;